module.exports = __webpack_public_path__ + "static/media/ALA_Diagram.72e4a5ac.png";